module.exports = "<template>\n    <section>\n        <b-field>\n            <b-input type=\"password\"\n                placeholder=\"Regular password input\">\n            </b-input>\n        </b-field>\n\n        <b-field>\n            <b-input type=\"password\"\n                placeholder=\"Password reveal input\"\n                password-reveal>\n            </b-input>\n        </b-field>\n    </section>\n</template>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/input/examples/ExPassword.vue
// module id = 1416
// module chunks = 13